import { Navigate } from "react-router-dom";
import type { AuthState } from "../lib/auth";

export function ProtectedRoute({ state, children }: { state: AuthState; children: React.ReactNode }) {
  if (state === "unknown") return <div className="p-8">Loading…</div>;
  if (state !== "logged_in") return <Navigate to="/login" replace />;
  return <>{children}</>;
}
